import { generateClient } from 'aws-amplify/api';

export const graphqlClient = generateClient();
